/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Code_Execution_Execute_ErrorInputs */

const es_tools_code_execution_execute_error = /** @type {(inputs: Tools_Code_Execution_Execute_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ejecutar código`)
};

const en_tools_code_execution_execute_error = /** @type {(inputs: Tools_Code_Execution_Execute_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error executing code`)
};

/**
* | output |
* | --- |
* | "Error executing code" |
*
* @param {Tools_Code_Execution_Execute_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_code_execution_execute_error = /** @type {((inputs?: Tools_Code_Execution_Execute_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Code_Execution_Execute_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_code_execution_execute_error(inputs)
	return en_tools_code_execution_execute_error(inputs)
});
export { tools_code_execution_execute_error as "tools.code_execution.execute_error" }